<div class="flex flex-row flex-wrap" [formGroup]="formGroup">
  @for (grouping of referenceDefinitions?.grouping || []; track grouping) {
    <mat-form-field class="flex-auto" floatLabel="always">
      <mat-label>{{ grouping.caption }}</mat-label>
      @if (grouping.options.length === 0) {
        <input matInput maxLength="40" [formControlName]="grouping.name + referenceIndex" (change)="userChange()">
      }
      @if (grouping.options.length > 0) {
        <mat-select [formControlName]="grouping.name + referenceIndex" (change)="userChange()">
          @for (option of grouping.options; track option) {
            <mat-option [value]="option.code">
              {{ option.caption }}
            </mat-option>
          }
        </mat-select>
      }
    </mat-form-field>
  }
</div>
